/**
 * Schutz gegen fremde Eingriffe ins DOM: Browser-Übersetzung (Chrome/Edge) und Erweiterungen (z. B. Grammarly)
 * ersetzen Textknoten, die React noch kennt. React scheitert dann beim Aktualisieren mit
 * „Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node“ und die Seite
 * bricht ab. Bekannter Workaround (facebook/react#11538): solche Aufrufe ins Leere laufen lassen statt abzustürzen –
 * React rendert beim nächsten Durchgang ohnehin den richtigen Stand.
 */
export function installDomGuard() {
  if (typeof Node !== "function" || !Node.prototype) return;
  const w = window as typeof window & { __lcDomGuard?: boolean };
  if (w.__lcDomGuard) return;
  w.__lcDomGuard = true;

  const removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) return child;
    return removeChild.call(this, child) as T;
  };

  const insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, node: T, ref: Node | null): T {
    if (ref && ref.parentNode !== this) return node;
    return insertBefore.call(this, node, ref) as T;
  };
}
